import Api from '../api';

import { errorHandler } from '../common';
const { axios: api } = Api;

export const createCallCenterCandidate = (payload) =>
	errorHandler(async () => {
		const data = await api.post(`/call-center-candidate/create`, payload);

		return { data: data.data };
	});

export const updateCallCenterCandidate = (payload, id) =>
	errorHandler(async () => {
		const data = await api.patch(
			`/call-center-candidate/update/${id}`,
			payload,
			{
				headers: {
					'content-type': 'multipart/form-data',
				},
			},
		);

		return { data: data.data };
	});

export const getCallCenterCandidates = () =>
	errorHandler(async () => {
		const data = await api.get(`/call-center-candidate/get`);

		return { data: data.data };
	});

export const getCallCenterCandidatesForManager = () =>
	errorHandler(async () => {
		const data = await api.get(`/call-center-candidate/get-for-manager`);

		return { data: data.data };
	});

export const getAllPossibleCandidateFields = () =>
	errorHandler(async () => {
		const data = await api.get(
			`/call-center-candidate/get-all-possible-fields`,
		);

		return { data: data.data };
	});

export const acceptCandidate = (date, id) =>
	errorHandler(async () => {
		const data = await api.post(`/call-center-candidate/accept/${id}`, {
			date,
		});

		return { data: data.data };
	});

export const rejectCandidate = (id) =>
	errorHandler(async () => {
		const data = await api.post(`/call-center-candidate/reject/${id}`);

		return { data: data.data };
	});

export const sendDocs = (payload, id) =>
	errorHandler(async () => {
		const data = await api.post(
			`/call-center-candidate/send-docs/${id}`,
			payload,
		);

		return { data: data.data };
	});

export const sendInstructions = (payload, id) =>
	errorHandler(async () => {
		const data = await api.post(
			`/call-center-candidate/send-instructions/${id}`,
			payload,
		);

		return { data: data.data };
	});

export const sendTargets = (id) =>
	errorHandler(async () => {
		const data = await api.post(`/call-center-candidate/send-targets/${id}`);

		return { data: data.data };
	});
